import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {StarsBackGround} from './components/starsbackground'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      
    <App />
    <div className="backgroundclass"><StarsBackGround></StarsBackGround></div>
    
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
